export default __webpack_public_path__ + "static/laminas_5-f19b8e08f5ef203fc4cf26a305a13f40.png";